import * as React from "react";
import { createContext, useContext } from "react";
const ProfileSectionsContext = createContext(null);
ProfileSectionsContext.displayName = "ProfileSectionsContext";
const useProfileSections = () => {
  const context = useContext(ProfileSectionsContext);
  if (context === null) {
    return {};
  }
  return context;
};
const ProfileSectionsProvider = ({ value, children }) => {
  return /* @__PURE__ */ React.createElement(ProfileSectionsContext.Provider, { value }, children);
};
export {
  ProfileSectionsContext,
  ProfileSectionsProvider,
  useProfileSections
};
//# sourceMappingURL=ProfileSectionsContext.js.map
